import { EditWorkflowsComponent } from './edit-workflows/edit-workflows.component';
import { IndexWorkflowsComponent } from './index-workflows/index-workflows.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';

const routes: Routes = [
    {
        path: 'edit',
        component: IndexWorkflowsComponent,
        canActivate: [AuthGuard] //RouteGuardService
    },
    {
        path: 'edit/:id',
        component: EditWorkflowsComponent,
        canActivate: [AuthGuard] // RouteGuardService
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class WorkflowsRoutingModule {}
